import React from 'react';
import { AIWidgetLoader } from 'components/widgetParts/AIWidgetLoader';
import { AIResponseType } from 'system/AIResponseTypes';
import { Box } from '@mui/material';
import { useDashboard } from 'routes/dashboard/Dashboard';
import withQueryWidget, { WithQueryWidgetProps } from 'components/widgetParts/queryWidgetComposition/withQueryWidget';

function AISummary(props: WithQueryWidgetProps): JSX.Element {
  const dashboard = useDashboard();

  return (
    <Box>
      <AIWidgetLoader
        {...props}
        dashboard={dashboard}
        canSaveWidgetCache={dashboard._modifiable}
        responseType={AIResponseType.SUMMARY}
      />
    </Box>
  );
}

export default withQueryWidget(AISummary, {
  hasSettingsDialog: true,
  hasQueryDialog: true,
  hideDataExports: true,
  showPDFExport: true,
});
